module.exports = __webpack_public_path__ + "img/mastercard.f711101a.png";